import {useMutation, useQuery} from 'admin/lib/apollo'
import {GET_SERVICE, CREATE_SERVICE, UPDATE_SERVICE} from 'admin/gql/Service.gql'
import useDestroyable from 'admin/hooks/useDestroyable'
import clearCache from './clearCache'

export default (organisationId, accountId, serviceId) => {
  const {data: {service = {}} = {}, error: getError} = useQuery(GET_SERVICE, {
    variables: {organisationId, serviceId},
    skip: !serviceId
  })

  const [create, {error: createError}] = useMutation(CREATE_SERVICE, {
    variables: {organisationId, accountId},
    flash: 'Service created',
    update: cache => clearCache({services: {organisationId, accountId}})(cache)
  })

  const [update, {error: updateError}] = useMutation(UPDATE_SERVICE, {
    variables: {organisationId, accountId, serviceId},
    flash: 'Service updated',
    update: (cache, {errors, data: {service}}) => {
      if (!errors) {
        let scope = {history: {itemType: 'AccountInternetService', itemId: serviceId}}

        if (String(accountId) !== String(service.accountId)) {
          scope.services = [{accountId}, {accountId: service.accountId}]
        }

        return clearCache(scope)(cache)
      }
    }
  })

  const {destroy, errors: destroyError} = useDestroyable('AccountInternetService', serviceId)

  return {
    service,
    errors: getError || createError || updateError || destroyError || {},
    create,
    update,
    destroy
  }
}
